import * as Field from '@/components/ui/field'
import { Text } from '@/components/ui/text'
import type { ParentComponent } from 'solid-js'
import { Flex } from 'styled-system/jsx'

export const OptionalField: ParentComponent = (props) => {
  return (
    <Flex justifyContent="space-between">
      <Field.Label class="field__label">{props.children}</Field.Label>
      <Text
        textStyle="xs"
        children="optional"
      />
    </Flex>
  )
}
